export enum NativePuffTypeEnum {
  HOME = 'home',
  SIDEBAR = 'sidebar',
}

export enum GaPreffixEnum {
  NATIVE_PUFF_HOME = 'NATIVE PUFF STARTPAGE',
  NATIVE_PUFF_LIST = 'NATIVE PUFF LISTPAGE',
  NATIVE_ARTICLE = 'NATIVE KAMPANJSIDA',
  GUIDE_LINK = 'GUIDE LINK',
}

export enum CustomerFeatureTypeEnum {
  LISTA_DITT_BARN = 'lista-ditt-barn',
  APP_STORE_BTN = 'app-store-btn',
  GOOGLE_PLAY_BTN = 'google-play-btn',
  MODAL_BOOKING = 'modal-booking',
  LISTA_DIG_IFRAME = 'lista-dig-iframe',
  LISTA_DIG_VARDEN = 'lista-dig-varden',
  LISTA_DIG_DIRECT = 'lista-dig-direct',
}

export enum IsCustomerDfpEnum {
  TRUE = 'true',
  FALSE = 'false',
  NA = 'na',
}
